import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ManualPayment } from "../../../models/invoice/manual-payment.model";
import { AlertService } from "../../../../core/alert.service";
import { CustomerManagementService } from "../../../services/customer.service";
import { InvoiceService } from "../../../services/invoice.service";
import { ManualPaymentService } from "../../../services/manual-payment.service";
import { MerchantService } from "../../../services/merchant.service";

@Component({
  selector: 'app-manual-payment',
  templateUrl: './manual-payment.component.html',
  styleUrls: ['./manual-payment.component.scss']
})
export class ManualPaymentComponent implements OnInit {
  @Input() invoiceModel: any;
  @Input() type: string = 'merchant'; // merchant or checkout
  @Input() canPayPartial: boolean = false;
  @Input() invoiceBalance: any = 0;
  @Input() paymentType: any = 1;

  clientName: string;
  manualPaymentModel: ManualPayment = new ManualPayment();
  paymentMethod: number = 0;
  paymentAmount: any;
  partialPaymentAmount: any;
  isCustomerLoading: boolean = true;
  isInvoicePartialPaymentSettingsLoading: boolean = true;
  busy: boolean = false;
  customerModel: any;

  minPaymentDate: string = moment(new Date()).format('YYYY-MM-DD');

  paymentDate: string;
  constructor(
    private modalRef: NgbActiveModal,
    private alert: AlertService,
    private customerApiService: CustomerManagementService,
    private invoiceService: InvoiceService,
    private merchantService: MerchantService,
    private manualPaymentService: ManualPaymentService  ) { }

  ngOnInit() {
    this.minPaymentDate = moment(new Date(this.invoiceModel.invoiceDate)).format('YYYY-MM-DD');
    this.getCustomer();
    this.loadBusinessInfo();
    this.invoiceBalance = this.invoiceBalance === 0 ? this.invoiceModel.balance : this.invoiceBalance;
    this.paymentAmount = this.invoiceBalance === 0 ? this.invoiceModel.balance : this.invoiceBalance;
    this.manualPaymentModel.InvoiceId = this.invoiceModel.id;
    this.manualPaymentModel.InvoiceNumber = this.invoiceModel.invoiceNumber;
    this.manualPaymentModel.PaymentType = this.paymentType;
    this.manualPaymentModel.CustomerId = this.invoiceModel.customerId;
    this.manualPaymentModel.EmailReceiptToClient = true;
  }


  close(data?: any) {
    this.modalRef.close(data);
  }

  getCustomer() {

    this.customerApiService.getCustomer(this.invoiceModel.customerId).subscribe((res: any) => {
      if (res) {
        this.customerModel = res;
        this.clientName = this.customerModel.CustomerTypeId === 2 ? this.customerModel.BusinessName : (this.customerModel.FirstName + " " + this.customerModel.LastName);
        this.manualPaymentModel.CustomerName = this.clientName;
        this.manualPaymentModel.CustomerEmail = this.customerModel.EmailAddress;

        if (!res.EmailAddress && res.CustomerTypeId == 2) {
          this.customerApiService.getCustomerContactPersons(this.invoiceModel.customerId).subscribe((list) => {
            let contact = list.filter((e) => { return e.IsMainContact });
            if (contact.length > 0) {
              this.manualPaymentModel.CustomerEmail = contact[0].EmailAddress;
            }
          });
        }

        this.customerApiService.getCustomerAddresses(this.invoiceModel.customerId).subscribe((addresses: any) => {
          // this.customerModel.CustomerAddressLoading = false;
          var address = addresses.filter((e) => { return e.IsDefault; });
          if (address.length > 0) {
            this.manualPaymentModel.CustomerAddress = `${(address[0].StreetAddress || '')} ${(address[0].City || '')} ${(address[0].State || '')} ${(address[0].Zip || '')}`;
          }
        }, (error: any) => {
            this.isCustomerLoading = false;
        }, () => {
            this.isCustomerLoading = false;
        });

        //this.manualPaymentModel.CustomerAddress =
      }
      //this.isCustomerLoading = false;
    });
  }

  loadBusinessInfo() {
    this.merchantService.getMerchant('1').subscribe((response: any) => {
      if (response) {
        this.manualPaymentModel.BusinessName = response.BusinessName;
        this.manualPaymentModel.BusinessLogo = response.Logo;
        this.manualPaymentModel.BusinessAddress = `${response.Address1 ? response.Address1 + ',' : ''} ${response.City ? response.City + ',' : ''} ${response.Province ? response.Province + ',' : ''} ${response.StateId || ''} ${response.PostalCode || ''} ${response.CountryCode || ''}`;
      }
    });
  }

  setPaymentType() {
    this.manualPaymentModel.PaymentType = this.paymentType;
    this.paymentAmount = parseInt(this.paymentType) === 2 ? this.partialPaymentAmount : this.invoiceBalance;
  }


  setPaymentMethod() {
    this.manualPaymentModel.PaymentMethod = this.paymentMethod;
  }

  setPaymentDate(e) {
    this.paymentDate = e.target.value;
  }

  isValidDate() {
    let paymentDate = Date.parse(this.paymentDate);

    return !isNaN(paymentDate);
  }

  saveManualPayment() {

    if (this.isModelValid()) {
      this.manualPaymentModel.Amount = parseFloat(this.paymentAmount);
      this.manualPaymentModel.PaymentDate = new Date(this.paymentDate);

      this.busy = true;
      this.manualPaymentService.addManualPayment(this.manualPaymentModel).subscribe((res) => {
        this.modalRef.close(res);
        this.alert.alertSuccess({ title: 'Success', text: 'Successfully created manual payment!' });
        this.busy = false;
      });
    }
    return;

  }

  isModelValid() {
    if (!this.isValidDate()) return false;
    if (this.paymentMethod == 0) return false;
    if (this.paymentType == 2 && this.paymentAmount == '') return false;
    if(!this.manualPaymentModel.TransactionReference) return false;

    return true;
  }

  forceMinDate(e) {
    if (e.target.value) {
      if (new Date(e.target.value) < new Date(e.target.min)) {
        e.target.value = e.target.min;
      }
    } else {
      e.target.value = e.target.min;
    }
  }


}
